import { createRouter, createWebHistory } from 'vue-router'
const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
        meta:{
			title: '文都教育合作招商'
		}
    },
    {
        path: '/contactUs',
        name: '联系我们',
        component: () => import('@/views/contactUs/index.vue'),
        meta:{
			title: '文都教育合作招商'
		}
    },
    {
        path:'/apply',
        name:'申请表单',
        component:()=>import('@/views/apply/index.vue'),
        meta:{
			title: '文都教育合作招商'
		}
    }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  })
export default router
